import type { LatestVersions, Machine } from '@couch/shared';
import { stoppedText } from '../machine/CloudPanel';
import { CloudBadge } from './CloudBadge';
import { hardwareLines, lastSeen, offlineHint, OS_LABEL, versionsLine } from './hardware';
import { MachineActions } from './MachineActions';
import { MachineUpdates } from './MachineUpdates';

export function MachineCard({ machine, latest }: { machine: Machine; latest?: LatestVersions | undefined }) {
  const titleId = `machine-${machine.id}`;
  return (
    <article className="machine-card" aria-labelledby={titleId}>
      <header className="machine-head">
        <h2 id={titleId}>{machine.name}</h2>
        <span className={`state ${machine.online ? 'state-online' : 'state-offline'}`}>{machine.online ? 'Online' : 'Offline'}</span>
      </header>
      <ul className="machine-facts">
        <li>{OS_LABEL[machine.os]}</li>
        {hardwareLines(machine).map((line) => <li key={line}>{line}</li>)}
        {versionsLine(machine) && <li className="muted">{versionsLine(machine)}</li>}
      </ul>
      {machine.hardware?.cloud && <CloudBadge cloud={machine.hardware.cloud} />}
      {!machine.online && machine.lastStop && <p className="muted">{stoppedText(machine.lastStop)}</p>}
      {!machine.online && (
        <p className="muted">
          {offlineHint(machine)} ({lastSeen(machine.lastSeenAt)})
        </p>
      )}
      <MachineUpdates machine={machine} latest={latest} />
      <MachineActions machine={machine} />
    </article>
  );
}
